import React, { ForwardedRef } from 'react'

const TooltipInformation = React.forwardRef((props, ref: ForwardedRef<SVGSVGElement>) => {
  return (
    <svg
      ref={ref}
      width="18"
      height="18"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M8 10.8L8 8M8 5.2L7.993 5.2M1 8C1 4.13401 4.13401 0.999999 8 1C11.866 1 15 4.13401 15 8C15 11.866 11.866 15 8 15C4.13401 15 1 11.866 1 8Z"
        stroke="#828282"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
})

export default TooltipInformation
